import React, {Component} from 'react';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import {
	changeCurrentPath,
	resetEntryDetailState,
	saveEntryState,
	resetEntryListState,
	fetchEntryDetailData,
	setEntryDetailState, setEntryListState
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import InnerForms from './components/inner-form';
import Tables from '../../common/components/table/editable-table';
import {COL_TYPE} from "../../common/utils/tables";
import {resetEditableTableState} from "../../actions/components";

import AlertDialog from '../../common/components/dialog/alert-dialog';
import {isObjectEquals} from "../../common/utils/array";
import Divider from "@material-ui/core/Divider";

const columns = [
	{name: 'ShohinCD', title: '商品コード', width: 110, type: COL_TYPE.EDIT, maxLength: 20},
	{name: 'ShohinName', title: '商品名', width: 200, type: COL_TYPE.EDIT, maxLength: 80},
	{name: 'JANCD', title: 'JANコード', width: 100, type: COL_TYPE.EDIT, maxLength: 13},
	{name: 'Kikaku', title: '規格', width: 100, type: COL_TYPE.EDIT, maxLength: 40},
	{name: 'CaseIrisu', title: '入数', width: 100, type: COL_TYPE.EDIT_NULLABLE_NUM},
	{name: 'Suryo', title: '数量', width: 100, type: COL_TYPE.EDIT_NULLABLE_NUM},
	{name: 'NisugataTani', title: '荷姿', width: 100, type: COL_TYPE.EDIT, maxLength: 10},
	{name: 'CaseJuryo', title: '重量', width: 110, type: COL_TYPE.EDIT_NULLABLE_NUM, max: 9999999.999, min: 0},
	{name: 'SeizouNO', title: '製造番号', width: 100, type: COL_TYPE.EDIT, maxLength: 20},
	{name: 'ShiyouKigen', title: '使用期限', width: 100, type: COL_TYPE.EDIT, maxLength: 20},
	{
		name: 'LotHyojiFlag', title: 'ロット表示フラグ', width: 150, type: COL_TYPE.EDIT_SELECT,
		selectDataSource: [
			{value: '0', name: '表示しない'},
			{value: '1', name: '表示する'}
		],
		hasBlank: false,
		defaultValue: '0'
	},
	{name: 'HacchuNO', title: '発注番号', width: 100, type: COL_TYPE.EDIT, maxLength: 20},
	{name: 'MeisaiBikou', title: '明細備考', width: 200, type: COL_TYPE.EDIT, maxLength: 40},
	{name: 'isDeleteDetail', title: ' ', width: 80, type: COL_TYPE.DELETE_ROW_BUTTON}
];


const styles = theme => ({


	heading: {
		fontSize: theme.typography.pxToRem(15),
	},
	expands: {
		boxShadow: 'initial'
	},
	divider: {
		marginTop: 15,
		marginBottom: 15
	},
});


class EntryDetail extends Component {

	constructor(props) {
		super(props);
		const id = !("id" in props.match.params) || !props.match.params.id || props.match.params.id === "0" ? null : props.match.params.id;

		this.state = {
			headerID: id,
			headerUpdateData: props.settings.headerData,
			errors: {},

			DataTeikyoumotoName: '',

			dialogOpen: props.settings.dialogOpen,
			cancelDialogOpen: false,
			backDialogOpen: false,
			duplicateDialogOpen: false,

			isUpdate: false,
			isUpdateRow: false,
			isDuplicate: props.settings.isDuplicate,
			isGetKeiyakuKigyou: props.settings.isGetKeiyakuKigyou,
		}
		this.nextIsMain = false;
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch, auth} = this.props;
		const SessionID = auth.SessionID;

		//dispatch(getJigyoshaList());
		//dispatch(getKeiyakuKigyouList());

		dispatch(fetchEntryDetailData({
			id: this.state.headerID,
			SessionID
		}));

	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.settings.isAfterFetch) {
			this.setState({
				headerUpdateData: nextProps.settings.headerData,
			})
			nextProps.dispatch(setEntryDetailState({
				isAfterFetch: false
			}))
		}

	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	componentWillUnmount() {
		const {dispatch} = this.props;
		dispatch(resetEntryDetailState());
		dispatch(resetEditableTableState());
		if (!this.nextIsMain) {
			//TABLE STATEをリセット
			dispatch(resetEntryListState());
		}
	}


	/** event handlers **/
	handleClickRegister = event => {
		const {dispatch, tableState} = this.props;
		dispatch(saveEntryState({
			id: this.state.headerID,
			headData: this.state.headerUpdateData,
			detailData: tableState.rows,
			SessionID: this.props.auth.SessionID
		}));

	};

	handleClickClear = () => {
		if (this.state.isUpdate || this.state.isUpdateRow) {
			this.setState({
				cancelDialogOpen: true
			})
		} else {
			this.doClear(this.state.headerID);
		}
	}

	handleClickBack = () => {
		if (this.state.isUpdate || this.state.isUpdateRow) {
			this.setState({
				backDialogOpen: true
			})
		} else {
			this.doCancel();
		}
	}

	handleAfterChangeFunc = (headerUpdateData, errors) => {
		const isUpdate = !isObjectEquals(headerUpdateData, this.props.settings.headerDataOrg);
		this.setState({
			headerUpdateData,
			errors,
			isUpdate
		});
	};

	handleAfterUpdateRow = (row, ret) => {
		this.setState({
			isUpdateRow: true
		});
		return Object.assign({}, row);
	}


	handleOkClearDialog = () => {
		this.setState({
			cancelDialogOpen: false
		})
		this.doClear(this.state.headerID);
	}
	handleCloseClearDialog = () => {
		this.setState({
			cancelDialogOpen: false
		})
	}
	handleOKBackDialog = () => {
		this.setState({
			backDialogOpen: false
		})
		this.doCancel();
	}
	handleCloseBackDialog = () => {
		this.setState({
			backDialogOpen: false
		})
	}
	handleOKContinueDialog = () => {
		this.setState({
			headerID: null
		})
		this.props.dispatch(setEntryListState({
			isAfterUpdate: true
		}));
		this.props.dispatch(setEntryDetailState({
			dialogOpen: false
		}));
		this.doClear(null);
	}
	handleCloseContinueDialog = () => {
		this.props.dispatch(setEntryListState({
			isAfterUpdate: true
		}));
		this.props.dispatch(setEntryDetailState({
			dialogOpen: false
		}));
		this.doCancel();
	}
	handleCloseDuplicateDialog = () => {
		this.props.dispatch(setEntryDetailState({
			isDuplicate: false
		}));
	}

	doClear = (id) => {
		const {dispatch} = this.props;
		const SessionID = this.props.auth.SessionID;


		dispatch(fetchEntryDetailData({
			id,
			SessionID
		}));

		this.setState({
			isUpdate: false,
			isUpdateRow: false
		})
	}
	doCancel = () => {
		this.nextIsMain = true;
		this.props.history.push('/entry-list');
	}


	render() {
		const {settings, classes, tableState} = this.props;
		const {data, dialogOpen, isDuplicate, headerData} = settings;

		const {cancelDialogOpen, backDialogOpen, headerUpdateData} = this.state;
		const allDisabled = Boolean(headerData["NiukeshoStatus"] !== "0" || headerData["NohinStatus"] !== "0");

		const rowError = tableState.errors.some((error) => {
			return error.hasError
		})
		const headError = Boolean(Object.keys(this.state.errors).length > 0);
		const noRow = Boolean(tableState.rows.length === 0);

		const registerDisabled = rowError || headError || noRow || allDisabled;


		const mainButtons = [
			{type: 'SAVE', func: this.handleClickRegister, text: "登録", disabled: registerDisabled},
			{type: 'CLEAR', func: this.handleClickClear, text: "クリア", disabled: allDisabled},
			{type: 'BACK', func: this.handleClickBack, text: "戻る", hasMargin: true}
		];


		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>伝票登録</h2>
					</section>
					<section className="with_button">
						<InnerForms
							dataSource={headerUpdateData}
							allDisabled={allDisabled}
							afterChangeFunc={this.handleAfterChangeFunc}
						/>
						<Divider className={classes.divider}/>
						<Tables
							dataSource={data}
							columns={columns}
							onAfterUpdateRow={this.handleAfterUpdateRow}
							useSelections={false}
							useFilters={false}
							useSorts={false}
							height={315}
							readOnly={allDisabled}
							canAddRow={true}
							isDefaultHasBlankRow={true}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<AlertDialog
					open={cancelDialogOpen}
					title={"確認"}
					text={<span>編集中のデータは破棄されます。<br/>よろしいですか？</span>}
					okFunction={this.handleOkClearDialog}
					closeFunction={this.handleCloseClearDialog}
				/>
				<AlertDialog
					open={backDialogOpen}
					title={"確認"}
					text={<span>編集中のデータは破棄されます。<br/>よろしいですか？</span>}
					okFunction={this.handleOKBackDialog}
					closeFunction={this.handleCloseBackDialog}
				/>
				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>登録が完了しました。<br/>続けて登録を行いますか？</span>}
					okFunction={this.handleOKContinueDialog}
					closeFunction={this.handleCloseContinueDialog}
				/>
				<AlertDialog
					open={isDuplicate}
					title={"確認"}
					text={<span>重複するデータが存在します。<br/>データを修正してください。</span>}
					okFunction={this.handleCloseDuplicateDialog}
					closeFunction={this.handleCloseDuplicateDialog}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal/>
				<LogoutModal/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.entryDetailSettings,
		listSettings: state.entryListSettings,
		tableState: state.componentsEditableTableState
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(EntryDetail);



// WEBPACK FOOTER //
// ./src/routes/entry-detail/index.js